module.exports = __webpack_public_path__ + "static/media/osvaldo-margato.2b643a51.png";